export enum ONEID_URL {
  ONE_ID = 'auth/oneid-callback?code=',
}
